import { render, staticRenderFns } from "./CheckViewSidebar.vue?vue&type=template&id=52b7697a&scoped=true&"
import script from "./CheckViewSidebar.vue?vue&type=script&lang=js&"
export * from "./CheckViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CheckViewSidebar.vue?vue&type=style&index=0&id=52b7697a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7697a",
  null
  
)

export default component.exports